(function() {
    const bookingOverlayButtons = Array.from(
        document.querySelectorAll('.js-cta-button-inquire')
    );

    const bookingOverlay = document.querySelector('.booking-overlay');
    if (bookingOverlayButtons && bookingOverlay) {
        bookingOverlayButtons.forEach(button =>
            button.addEventListener('click', () => {
                // link directly to inquiry page on mobile devices
                if (window.matchMedia('(max-width: 1158px)').matches && button.dataset.uri) {
                    window.location = button.dataset.uri
                    return;
                }

                const event = new Event('showBookingOverlay');
                bookingOverlay.dispatchEvent(event);
            })
        );
    }
})();
